import {Component, OnDestroy, OnInit} from '@angular/core';
import {GridOptions} from 'ag-grid-community';
import {UserSelectionService} from './user-selection-service';
import AppConstants from '../common-components/AppConstants';
import {AlertService} from '../../services/alert/alert.service';
import {User} from '../../services/user/user';
import {Subscription} from 'rxjs';
import {UserService} from '../../services/user/user.service';
import {LoadingService} from '../../services/loading/loading.service';
import {Router} from '@angular/router';
import { HttpClient } from '@angular/common/http';
@Component({
    selector: 'app-user-selection',
    templateUrl: './user-selection.component.html',
    styleUrls: ['./user-selection.component.css'],
    standalone: false
})
export class UserSelectionComponent implements OnInit, OnDestroy {

  public rowClassRules: any;
  gridOptions: GridOptions = this.initializeGridOptions();
  currentUser: User | any;
  private user_subscription: Subscription;
  private redirectUrl: string | null | undefined;

  public gridApi: { setGridOption: (arg0: string, arg1: number) => void; sizeColumnsToFit: () => void; };
  public gridColumnApi: any;
  public overlayNoRowsTemplate;
  public columnDefs;
  public defaultColDef;
  public rowSelection: any;
  public rowData: any;

  getRowHeight(params: any) {
    return 35;
  }

  constructor(private http: HttpClient, private userSelectionService: UserSelectionService, private alertService: AlertService, private userService: UserService, private loader: LoadingService, private router: Router) {
    this.user_subscription = this.userService.getCurrentUserDetails().subscribe((currentUser: any) => {
      if (AppConstants.isNotNullCondition(currentUser)) {
        this.currentUser = currentUser;
        this.currentUser.isRoleSelected = false;
        this.userService.removeUserSessionByUserId(this.currentUser);
        // this.removeUserSessionByUserId(this.currentUser.id);
        localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
        this.userService.setUserObservable(this.currentUser);
      }
      this.loader.hide();
    }, (error1: any) => {
      this.loader.hide();
      this.alertService.info('unable to get current user details');
    });
    this.overlayNoRowsTemplate = '<span style="margin-top: 90px;">No results found. Please adjust your filters.</span>';
    this.columnDefs = [
      {
        headerName: 'Email',
        field: 'email',
        cellRenderer: (params: { data: { email: string; }; }) => {
          return '<a tabindex="0">' + params.data.email + '</a>';
        },
        onCellClicked: (event: { data: any; }) => this.onAccountSelect(event.data)
      },
      {
        headerName: 'Permission',
        field: 'permission'
      },
      {
        headerName: 'Role Name',
        field: 'roleName'
      },
      {
        headerName: 'Agency Name',
        valueGetter: function (params: { data: { agencyName: any; }; }) {
          return ((AppConstants.isNotNullCondition(params.data.agencyName) ? params.data.agencyName : ''));
        }
      },
      {
        headerName: 'Bureau Name',
        valueGetter: function (params: { data: { agencyBureauName: any; }; }) {
          return ((AppConstants.isNotNullCondition(params.data.agencyBureauName) ? params.data.agencyBureauName : ''));
        }
      },
      {
        headerName: 'Authorized Official',
        valueGetter: function (params: { data: { lastName: any; firstName: string; }; }) {
          return ((AppConstants.isNotNullCondition(params.data.lastName) ? params.data.lastName : '')
            + (AppConstants.isNotNullCondition(params.data.firstName) ? ', ' + params.data.firstName : ''));
        }
      },
      {
        headerName: 'TSP Name',
        cellRenderer: (params: { data: { scac: any; scacName: string; }; }) => {
          return ((AppConstants.isNotNullCondition(params.data.scac) ? params.data.scac : '')
            + (AppConstants.isNotNullCondition(params.data.scacName) ? ' - ' + params.data.scacName : ''));
        },
      }
    ];
    this.defaultColDef = {
      sortable: true,
      resizable: true,
      autoHeight: true,
      filter: 'agTextColumnFilter',
      filterParams: {
        maxNumConditions : 1
      }
    };
    this.rowClassRules = {
      'font-sans-3xs': 'true'
    };
  }


  /**
   * The gridOptions is a 'one stop shop' for the entire interface into the grid. The grid options can be used regardless of the framework you are using, however if you are using a framework,
   * you can additionally achieve what grid options provides with your frameworks bindings. How to configure for the particular framework is explained further down this page.
   * we are using infinite row model which will call server to get data every time page changes
   */

  ngOnInit() {
  }

  private initializeGridOptions() {
    return <GridOptions>{
      pagination: true,
      paginationPageSize: 25,
      cacheBlockSize: 25,
      domLayout: 'autoHeight',
      rowHeight: 45,
      getRowHeight: () => 35,
    };
  }

  onAccountSelect($e: any) {
    this.userSelectionService.saveUSerRoleWithSession($e).subscribe((result: any) => {
      // In some flows currentUser is not yet hydrated when selection returns.
      if (!this.currentUser) {
        const savedCurrentUser = localStorage.getItem('currentUser');
        this.currentUser = savedCurrentUser ? JSON.parse(savedCurrentUser) : null;
      }

      if (!this.currentUser) {
        this.alertService.error('Unable to update selected role. Please refresh and try again.');
        return;
      }

      this.currentUser.isRoleSelected = true;
      localStorage.setItem('currentUser', JSON.stringify(this.currentUser));
      this.userService.setUserObservable(this.currentUser);
      this.redirectUrl = '/landing';
      if (this.redirectUrl) {
        // using router navigation to navigate to landing page
        this.router.navigate([this.redirectUrl]);
        this.redirectUrl = null;
      }
      this.alertService.success('Success!!!');
    }, (error1: any) => {
      this.alertService.error('error saving the user session, please try again');
    });
  }

  onGridReady(params: { api: any; columnApi: any; }) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
    // this.gridApi.setHeaderHeight(35);
    this.gridApi.setGridOption('headerHeight', 35);
    this.gridApi.sizeColumnsToFit();
    this.userSelectionService.getMultiUserRoles().subscribe((data: any) => {
      if (AppConstants.isNotNullCondition(data)) {
        this.rowData = data;
      }
    }, (error: any) => {
      this.alertService.error('error while getting multi user details');
    });
  }

  ngOnDestroy(): void {
    if (this.user_subscription) {
      this.user_subscription.unsubscribe();
    }
  }

}
